// ABOUTME: Cross-browser image copy via Clipboard API with Safari user-gesture handling
// ABOUTME: Falls back to data URL via writeText() when ClipboardItem API is unavailable

export type CopyImageMode = "native" | "dataUrl"

/**
 * Копирует изображение в буфер обмена.
 *
 * Safari требует, чтобы `navigator.clipboard.write` был вызван внутри
 * user-gesture. Любой `await` до него гасит контекст и приводит к
 * `NotAllowedError`. Поэтому `produceBlob` передаётся как `Promise<Blob>`
 * прямо в `ClipboardItem` — Safari удерживает гестур до его резолва.
 *
 * Если конструктор `ClipboardItem` или `clipboard.write` недоступны (старые
 * браузеры), используется фолбэк через `writeText` с data URL.
 *
 * Бросает исключение при любой ошибке записи в буфер.
 */
export async function copyImageToClipboard(
  produceBlob: () => Promise<Blob>,
  produceDataUrl: () => Promise<string>,
): Promise<CopyImageMode> {
  const clipboard = navigator.clipboard as Clipboard | undefined
  const hasClipboardItem = typeof ClipboardItem !== "undefined"

  if (!clipboard?.write || !hasClipboardItem) {
    const dataUrl = await produceDataUrl()
    await navigator.clipboard.writeText(dataUrl)
    return "dataUrl"
  }

  await clipboard.write([new ClipboardItem({ "image/png": produceBlob() })])
  return "native"
}
